module.exports = __webpack_public_path__ + "static/img/extend_logo.94f4eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extend_logo.png
// module id = uHY3
// module chunks = 1